// extracted by mini-css-extract-plugin
module.exports = {"image":"HomeCustomersSection_image__8vqDS","bottomButton":"HomeCustomersSection_bottomButton__0O5t6","container":"HomeCustomersSection_container__72dhl"};